CCL.faqSlider = {
  autoload: [
    ['faqSlide', $('body').length > 0],
    ['handleShowFAQs', $('body').length > 0]
  ],

  readAllFAQText: '',
  readTopFAQText: '',

  faqSlide() {
    $('body').find('.faq-button').click(() => {
      $('body').find('.category-overlay').remove();
      $('body').find('.c-products-faq').addClass('open');
      $('body').find('.faq-back-link').addClass('ada-highlighted');
      $('body').find('.faq-back-link').focus();
      $('body').append('<div class="category-overlay" style="z-index:9998"><div>');
      $('body').addClass('add-category-overlay');
    });
    $('.faq-back-link').click(() => {
      $('body').find('.c-products-faq').toggleClass('open');
      $('body').find('.faq-button').addClass('ada-highlighted');
      $('body').find('.faq-button').focus();
      $('.category-overlay').remove();
      $('body').removeClass('add-category-overlay');
    });
  },

  handleShowFAQs() {
    $('body').on('click', '.all-faq-link', (e) => {
      this.readTopFAQText = $(e.currentTarget).attr('data-faqtext');
      if (e.currentTarget.textContent === this.readTopFAQText) {
        $('.read-top-faq').css('display', 'block');
        $('.read-all-faq').css('display', 'none');
        e.currentTarget.textContent = this.readAllFAQText;
      } else {
        $('.read-top-faq').css('display', 'none');
        $('.read-all-faq').css('display', 'block');
        this.readAllFAQText = e.currentTarget.textContent;
        e.currentTarget.textContent = this.readTopFAQText;
      }
    });
    $('.all-faq-link').on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        $(() => {
          $('.faq-back-link').addClass('ada-highlighted');
          $('.faq-back-link').focus();
        });
      }
    });
    $('.faq-back-link').on('keydown', (event) => {
      if ((event.keyCode === 9) && event.shiftKey) {
        $(() => {
          $('.all-faq-link').addClass('ada-highlighted');
          $('.all-faq-link').focus();
        });
      }
    });

    const lastCard = $('.c-products-faq .read-top-faq .card').last();
    const faqEl = $(lastCard).find('.card-header');
    console.dir(lastCard);
    $(faqEl).on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        if (!($('.all-faq-link').length)) {
          $(() => {
            $('.faq-back-link').addClass('ada-highlighted');
            $('.faq-back-link').focus();
          });
        }
      }
    });

    $('.accordion-toggle').click((e) => {
      $(e.currentTarget).addClass('ada-highlighted');
      $(e.currentTarget).focus();
      const expanded = $(e.currentTarget).attr('aria-expanded');
      if (expanded === 'true') {
        $(e.currentTarget).attr('aria-expanded', 'false');
      } else {
        $(e.currentTarget).attr('aria-expanded', 'true');
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-products-faq/faq-slider.js